import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ForumMockService } from '../forum-mock.service';
import { ForumCommunity, ForumPost, ForumSort } from '../forum.types';

@Component({
  selector: 'app-forum-home',
  templateUrl: './forum-home.component.html',
  styleUrls: ['./forum-home.component.css'],
})
export class ForumHomeComponent implements OnInit {
  communities: ForumCommunity[] = [];
  posts: ForumPost[] = [];
  sort: ForumSort = 'hot';
  totalMembers = 0;

  // Composer (modal)
  composerVisible = false;
  draftCommunityId = '';
  draftTitle = '';
  draftBody = '';
  draftTag = 'Dúvida';
  readonly tagOptions = ['Dúvida', 'Guia', 'Build', 'Discussão'];

  constructor(private forum: ForumMockService, private router: Router) {}

  ngOnInit(): void {
    this.communities = this.forum.getCommunities();
    this.totalMembers = this.forum.getTotalMembers();
    this.refresh();
  }

  refresh(): void {
    this.posts = this.forum.getPosts(this.sort);
  }

  setSort(s: ForumSort): void {
    this.sort = s;
    this.refresh();
  }

  openCommunity(c: ForumCommunity): void {
    this.router.navigate(['/forum/c', c.slug]);
  }

  short(n: number): string {
    if (n >= 1000) return (n / 1000).toFixed(1).replace('.0', '') + 'k';
    return `${n}`;
  }

  // ── Composer ──
  openComposer(): void {
    this.draftCommunityId = this.communities[0]?.id ?? '';
    this.draftTitle = '';
    this.draftBody = '';
    this.draftTag = 'Dúvida';
    this.composerVisible = true;
  }

  get canSubmit(): boolean {
    return this.draftTitle.trim().length >= 6 && !!this.draftCommunityId;
  }

  submitPost(): void {
    if (!this.canSubmit) return;
    const post = this.forum.createPost({
      communityId: this.draftCommunityId,
      title: this.draftTitle,
      body: this.draftBody,
      tag: this.draftTag,
    });
    this.composerVisible = false;
    this.sort = 'new';
    this.refresh();
    // Leva direto para o post recém-criado
    this.router.navigate(['/forum/post', post.id]);
  }
}
